import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AccordionItem } from '../../Molecules';

const FAQ = ({ value }) => {
  const {
    heading,
    intro,
    faqs = [],
  } = value;

  return (
    <section className="section section-default-width">
      <div className="section__inner">

        {(heading || intro) && (
          <div className="section__header block-align-center">
            {heading && <div className="text-section-title">{heading}</div>}
            {intro && <div className="text-lead">{intro}</div>}
          </div>
        )}

        {faqs.length > 0 && (
          <div className="section__body">
            <div className="block">
              <div className="block__body">
                <div className="stack stack-normal">
                  {faqs.map((faq, index) => (
                    <AccordionItem
                      key={index}
                      question={faq.question}
                      answer={faq.answer}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </section>
  );
};

FAQ.propTypes = {
  value: PropTypes.shape({
    heading: PropTypes.string,
    intro: PropTypes.string,
    faqs: PropTypes.arrayOf(
      PropTypes.shape({
        question: PropTypes.string.isRequired,
        answer: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
};

export default FAQ;